import { createContext, useContext } from 'react'

const IdentityContext = createContext(false)

export const IdentityProvider = IdentityContext.Provider

export const useIdentityReady = () => useContext(IdentityContext)
